import { useEffect, useState } from 'react';
import { Typography, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper } from '@mui/material';
import { getContatos } from '../services/api';

const ConfigPage = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    getContatos().then(setRows).catch(console.error);
  }, []);

  return (
    <div>
      <Typography variant="h5" fontWeight={900} mb={2}>Contatos WhatsApp</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Número</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(c => (
              <TableRow key={c.id} hover>
                <TableCell>{c.nome}</TableCell>
                <TableCell>{c.numero}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ConfigPage;
